// Reposiciona a calculadora de frete acima do popup-link (Tabela de medidas)
document.addEventListener('DOMContentLoaded', function() {
  var calc = document.querySelector('.custom-shipping-calculator');
  var popupLink = document.querySelector('.popup-link');
  if (calc && popupLink && popupLink.parentNode) {
    popupLink.parentNode.insertBefore(calc, popupLink);
  }
});

// ============================================================
// CALCULADOR DE FRETE — handler via delegação
// Funciona em PDP e quickview via event delegation no document
// ============================================================
(function() {
  function calcConvertToReal(value) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  function calcRemoveProduct(variantId) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 })
    });
  }

  function calcSetLoading(btn, loading) {
    var loader = btn.parentElement ? btn.parentElement.querySelector('.custom-shipping-calc-loader') : null;
    if (loading) {
      btn.style.display = 'none';
      if (loader) loader.style.display = 'inline-flex';
    } else {
      btn.style.display = '';
      if (loader) loader.style.display = 'none';
    }
  }

  function calcShipping(btn, zipCode, variantId) {
    var parent = btn.closest('.custom-shipping-calculator');
    var country = 'Brazil';
    var province = '';
    var ufMap = {
      AC:'Acre', AL:'Alagoas', AM:'Amazonas', AP:'Amapá', BA:'Bahia',
      CE:'Ceará', DF:'Distrito Federal', ES:'Espírito Santo', GO:'Goiás',
      MA:'Maranhão', MG:'Minas Gerais', MS:'Mato Grosso do Sul', MT:'Mato Grosso',
      PA:'Pará', PB:'Paraíba', PE:'Pernambuco', PI:'Piauí', PR:'Paraná',
      RJ:'Rio de Janeiro', RN:'Rio Grande do Norte', RO:'Rondônia', RR:'Roraima',
      RS:'Rio Grande do Sul', SC:'Santa Catarina', SE:'Sergipe', SP:'São Paulo',
      TO:'Tocantins'
    };

    calcSetLoading(btn, true);
    parent.classList.add('loading');

    fetch('//viacep.com.br/ws/' + zipCode + '/json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.erro) {
          alert('CEP não encontrado.');
          parent.classList.remove('loading'); calcSetLoading(btn, false);
          return;
        }
        province = ufMap[data.uf ? data.uf.toUpperCase() : ''] || '';
        if (!province) {
          alert('Estado não identificado.');
          parent.classList.remove('loading'); calcSetLoading(btn, false);
          return;
        }

        fetch('/cart/shipping_rates.json?shipping_address[zip]=' + zipCode +
              '&shipping_address[country]=' + country +
              '&shipping_address[province]=' + encodeURIComponent(province))
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var rates = data.shipping_rates || [];
            var ratesContainer = parent.querySelector('.shipping-rates');
            ratesContainer.innerHTML = '<p><strong>' +
              (rates.length > 1 ? 'Existem ' + rates.length + ' tipos de frete disponíveis.' :
               rates.length === 1 ? 'Existe 1 tipo de frete disponível.' :
               'Nenhuma opção de frete encontrada.') +
              '</strong></p>';
            rates.forEach(function(rate) {
              var days = rate.delivery_days && rate.delivery_days[0];
              var printDays = days > 0 ? ' - ' + days + (days === 1 ? ' dia útil' : ' dias úteis') : '';
              var printPrice = rate.price > 0 ? calcConvertToReal(rate.price) : 'Grátis';
              var li = document.createElement('li');
              li.innerHTML = '<strong>' + rate.name + '</strong> - ' + printPrice + printDays;
              ratesContainer.appendChild(li);
            });
            parent.classList.remove('loading'); calcSetLoading(btn, false);
            if (variantId) calcRemoveProduct(variantId);
          })
          .catch(function() {
            alert('Erro ao calcular frete. Tente novamente.');
            parent.classList.remove('loading'); calcSetLoading(btn, false);
            if (variantId) calcRemoveProduct(variantId);
          });
      })
      .catch(function() {
        alert('CEP inválido. Verifique e tente novamente.');
        parent.classList.remove('loading'); calcSetLoading(btn, false);
      });
  }

  // Máscara de CEP sem biblioteca externa
  document.addEventListener('input', function(e) {
    if (!e.target.classList.contains('custom_zip_code')) return;
    var v = e.target.value.replace(/\D/g, '').substring(0, 8);
    e.target.value = v.length > 5 ? v.substring(0, 5) + '-' + v.substring(5) : v;
  }, true);

  // Delegação de clique — funciona para PDP e quickview
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.custom_shipping_button');
    if (!btn) return;

    var parent = btn.closest('.custom-shipping-calculator');
    if (!parent) return;

    var zipCode = (parent.querySelector('.custom_zip_code') || {}).value || '';
    zipCode = zipCode.replace(/\D/g, '');

    if (zipCode.length !== 8) {
      alert('Digite um CEP válido (8 dígitos).');
      return;
    }

    var isProduct = parent.getAttribute('data-template') === 'product';

    if (!isProduct) {
      calcShipping(btn, zipCode, null);
      return;
    }

    // Página de produto: busca o form pelo atributo data-type do tema Horizon
    var productForm = parent.closest('[data-product-id]');
    var form = (productForm ? productForm.querySelector('form[data-type="add-to-cart-form"]') : null)
            || document.querySelector('form[data-type="add-to-cart-form"]');

    if (!form) {
      alert('Formulário do produto não encontrado.');
      return;
    }

    var variantInput = form.querySelector('[name="id"]');
    var variantId = variantInput ? variantInput.value : null;

    if (!variantId) {
      alert('Variante não identificada.');
      return;
    }

    calcSetLoading(btn, true);
    parent.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() { calcShipping(btn, zipCode, variantId); })
    .catch(function() {
      parent.classList.remove('loading'); calcSetLoading(btn, false);
      alert('Não foi possível calcular o frete. Tente novamente.');
    });
  });
})();
